export enum TipEntryMode {
  PRESET_BUTTONS = "PRESET_BUTTONS",
  TOTAL_AMOUNT_ONLY = "TOTAL_AMOUNT_ONLY",
}
